import { ObservableFromFetch } from "../ObservableFromFetch"
import UserInformation from "./Model/UserInformation"

export function UserInformationObservable(userName: string, IsOrderSecurityOverride: boolean, exactMatch: boolean = true) {
  const requestBody: string = JSON.stringify({ UserName: userName })
  return ObservableFromFetch<UserInformation[]>("FFOrderUserFileMaintenance/GetUserInformation", requestBody)
}

export function UserNotificationInformationObservable(userName: string, IsOrderSecurityOverride: boolean, exactMatch: boolean = true) {
  const requestBody: string = JSON.stringify({ UserName: userName })
  return ObservableFromFetch<UserInformation[]>("FFOrderUserFileMaintenance/GetUserNotificationInformation", requestBody)
}

export function ActiveUserInformationGetObservable(userName: string, isActivateUser: boolean = false) {
  const requestBody: string = JSON.stringify({ UserName: userName, IsActivateUser: isActivateUser })
  return ObservableFromFetch<UserInformation[]>("FFOrderUserFileMaintenance/GetActiveUserInformation", requestBody)
}